/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:767.98px){.article-thumbnail[_ngcontent-%COMP%]{width:160px!important;height:180px!important;border-radius:5px}}"];
export { styles as styles };
